<template>
  <div class="schedule">
    <!--<above-nav></above-nav>-->
    <div class="content-wrapper">
      <div class="content">
        <router-link tag="div" to="/console/lesson/class" class="back">< 返回班级列表</router-link>
        <div class="classinfo-wrapper">
          <img class="info-img" :src="imgprefix+lessoninfo.faceimg" alt="img" width="180" height="120">
          <div class="classinfo-text-wrapper">
            <h2 class="classinfo-text-title">
              {{decodeURIComponent(lessoninfo.lessonname)}}
            </h2>
            <p class="classinfo-text-row">
              班级:{{decodeURIComponent(classinfo.classmodename)}}-{{decodeURIComponent(classinfo.classname)}}
            </p>
            <p class="classinfo-text-row" v-if="classHourInfo!=null&& classinfo.democlass=='0'">
              预计剩余课次:{{classHourInfo.classnums}}次<span class="split"></span>已上完课时:{{computeTotalHour(classHourInfo.finishedclasshour)}}<span
              class="split"></span>总课时:{{computeTotalHour(classHourInfo.classhour)}}
            </p>
          </div>
          <div class="button-group" style="float: right">
            <el-button type="primary" @click="shareClass">邀请学生</el-button>
            <el-button type="primary" @click="$store.commit('setUpdateClassDialog', true)" v-if="lessoninfo.lessontype == 1">修改班级</el-button>
          </div>
        </div>
        <middle-nav :list="middleList"></middle-nav>
        <div class="catalog-free-wrapper" v-if="classinfo.democlass==1">
          <h2 class="catalog-title">试听课程表
            <button class="add-btn" v-if="scheduleList&&scheduleList[0]" @click="showFreeAddWare">添加课件
              <template v-if="scheduleList&&scheduleList[0]">
                ({{scheduleList[0].coursewarenums}})
              </template>
            </button>
            <button v-if="scheduleList&&scheduleList[0]" class="check-btn"
                    :class="{'show':freeWareShow,'not-show':!freeWareShow}" @click="openFreeCourseWare">查看课件
            </button>

          </h2>
          <div class="wareList-wrapper" v-if="freeWareShow">
            <template v-if="!isEmpty(classWareList)">
              <p class="already-title">已添课件：</p>
              <div class="ware-item" v-for="(item,index) in classWareList">
                <div class="ware-img-wrapper">
                  <img :src="imgprefix+item.faceimg" alt="课件封面" width="60" height="40">
                </div>
                <p class="courseware-name">{{decodeURIComponent(item.coursewarename)}}</p>
                <section class="courseware-btn-wrapper">
                  <button class="courseware-btn transparent" @click="previewWare(item)">预览</button>
                  <button class="courseware-btn transparent" @click="editWare(item)">编辑</button>
                  <button class="courseware-btn del" @click="delFreeWare(item,index)">删除</button>
                </section>
              </div>
            </template>
            <p v-else style="text-align:center;font-size: 16px;color:#666;font-weight:bold">暂无课件</p>
          </div>
          <div class="catalog-list-wrapper">
            <div class="catalog-list-item" v-for="(item,index) in scheduleList"
                 v-if="(index>=(currentPage-1)*10)&&(index<currentPage*10)">
              <span class="catalog-item-time">{{item.planstarttime.substring(0, 10)}}</span>
              <span class="done" v-if="item.statusflag=='1'"></span>
              <span class="ongoing" v-if="item.statusflag=='2'">正在上课</span>
              <span class="not-start" v-if="item.statusflag=='0'">未开始</span>
              <button class="go-class" @click="gotoLive(item)"
                      v-if="item.statusflag!='1'||isSameDay(returnServerToday,item.planstarttime.substring(0,10))">
                进入上课
              </button>
              <button class="back-live"
                      v-if="item.statusflag==1&&item.txtfilename!==''&&item.mp3filename!==''"
                      @click="reviewLive(item)">回顾直播
              </button>
              <span class="enroll-check">
                <span>{{item.enrollnums}}人报名 |</span>
                <span class="check"
                      :class="{'not-allow':item.enrollnums==0}"
                      @click="showEnrollPeople(item)">查看</span>
              </span>
            </div>
          </div>
          <template v-if="totoalPage>10">
            <el-pagination
              background
              layout="prev, pager, next"
              :current-page.sync="currentPage"
              @current-change="handleCurrentChange"
              :page-size="10"
              :total="totoalPage">
            </el-pagination>
          </template>
        </div>
        <div class="catalog-cost-wrapper" v-if="classinfo.democlass==0">
          <div class="catalog-title-wrapper">
            <h2 class="catalog-title">课程目录表</h2>
            <p class="hint">课程目录调整：正式课中只有把未开始的课程上完，课程目录中才会生成新的一节课</p>
            <button class="add-btn" @click="showCatalog">修改课程目录</button>
          </div>
          <div class="catalog-list-wrapper">
            <template v-for="(item,index) in scheduleList" v-if="(index>=(currentPage-1)*10)&&(index<currentPage*10)">
              <div class="catalog-list-item">
                <span class="catalog-item-title">{{totoalPage-index}}、{{decodeURIComponent(item.catalogname)}}</span>
                <span class="done" v-if="item.statusflag=='1'"></span>
                <span class="ongoing" v-if="item.statusflag=='2'">正在上课</span>
                <span class="not-start" v-if="item.statusflag=='0'">未开始</span>
                <button class="go-class" @click="gotoLive(item)"
                        v-if="item.statusflag!='1'||isSameDay(returnServerToday,item.planstarttime.substring(0,10))">
                  进入上课
                </button>
                <button class="back-live"
                        v-if="item.statusflag==1&&item.txtfilename!==''&&item.mp3filename!==''"
                        @click="reviewLive(item)">回顾直播
                </button>
                <button class="add-ware-btn" @click="showCostAddWare(item,index)">添加课件({{item.coursewarenums}})</button>
                <button class="check-btn" :class="{'show':item.show,'not-show':!item.show}"
                        @click="checkCourseWare(item,index)">查看课件
                </button>
                <span class="catalog-item-time">{{item.planstarttime.substring(0, 10)}}</span>
              </div>
              <div class="wareList-wrapper" v-if="item.show">
                <template v-if="!isEmpty(item.coursewarelist)">
                  <div class="ware-item" v-for="(data,index2) in item.coursewarelist">
                    <div class="ware-img-wrapper">
                      <img :src="imgprefix+data.faceimg" alt="课件封面" width="60" height="40">
                    </div>
                    <p class="courseware-name">{{decodeURIComponent(data.coursewarename)}}</p>
                    <section class="courseware-btn-wrapper">
                      <button class="courseware-btn transparent" @click="previewWare(data)">预览</button>
                      <button class="courseware-btn transparent" @click="editWare(data)">编辑</button>
                      <button class="courseware-btn del" @click="delCostWare(data,index,index2)">删除</button>
                    </section>
                  </div>
                </template>
                <p v-else style="text-align:center;font-size: 16px;color:#666;font-weight:bold">暂无课件</p>
              </div>
            </template>
          </div>
          <template v-if="totoalPage>10">
            <el-pagination
              background
              layout="prev, pager, next"
              :current-page.sync="currentPage"
              @current-change="handleCurrentChange"
              :page-size="10"
              :total="totoalPage">
            </el-pagination>
          </template>
        </div>
      </div>
    </div>
    <div class="catalogPop" v-if="catalogShow">
      <div class="catalogPop-content-wrapper">
        <h2 class="title">修改课程目录</h2>
        <p class="totalnum">共{{totoalPage}}课</p>
        <div class="catalog-wrapper">
          <div class="list">
            <template v-for="(item,index) in catalogListChange"
                      v-if="(index>=(currentCatalog-1)*20)&&(index<(currentCatalog-1)*20+10)">
              <section class="row">
                <span class="index">{{totoalPage-index}}、</span>
                <input type="text"
                       class="text"
                       :class="{'danger':item.catalogname==''}"
                       v-model="item.catalogname"
                       placeholder="目录不能为空">
              </section>
            </template>
          </div>
          <div class="split"></div>
          <div class="list">
            <template v-for="(item,index) in catalogListChange"
                      v-if="(index>=(currentCatalog-1)*20+10)&&(index<currentCatalog*20)">
              <section class="row">
                <span class="index">{{index + 1}}、</span>
                <input type="text"
                       class="text"
                       :class="{'danger':item.catalogname==''}"
                       v-model="item.catalogname"
                       placeholder="目录不能为空">
              </section>
            </template>
          </div>
          <el-pagination
            background
            layout="prev, pager, next"
            :current-page.sync="currentCatalog"
            @current-change="ChangeCatalogPage"
            :page-size="20"
            :total="totoalPage">
          </el-pagination>
        </div>
        <div class="btn-wrapper-out">
          <div class="btn-wrapper-inside">
            <button class="cancel" @click="catalogShow=false">取消</button>
            <button class="confirm" @click="save">确认</button>
          </div>
        </div>
      </div>
    </div>
    <div class="warePop" v-if="warePopShow">
      <div class="ware-content-wrapper">
        <h3 class="ware-title">选择课件</h3>
        <div class="flex-wrapper">
          <p class="left">已选择：{{count}}个</p>
          <p class="right" @click="gotoMake">制作新课件</p>
        </div>
        <div class="ware-wrapper">
          <template v-for="(item,index) in lessonWareList">
            <div class="classware">
              <img class="cover" :src="computeUrl(item.faceimg)" alt="cover" width="80" height="60">
              <div class="classware-middle">
                <h3 class="title">{{decodeURIComponent(item.coursewarename)}}</h3>
                <p class="introduce">{{decodeURIComponent(item.introduce)}}</p>
              </div>
              <img v-if="item.show===false"
                   @click="show(item,index)"
                   class="del"
                   src="./beforeSelect.png"
                   alt="delete-button" width="20"
                   height="20">
              <img v-if="item.show===true"
                   @click="item.show=false;count--"
                   class="del"
                   src="./selected.png"
                   alt="delete-button" width="20"
                   height="20">
            </div>
          </template>
        </div>
        <div class="ware-btn-outside">
          <div class="ware-btn-inside">
            <button class="cancel" @click="warePopShow=false;">取消</button>
            <button class="confirm" @click="addWare">确定</button>
          </div>
        </div>
      </div>
    </div>
    <div class="enrollpop-wrapper" v-if="enrollShow">
      <div class="enrollpop">
        <h2 class="title">报名列表</h2>
        <img class='close'
             @click="enrollShow=false;"
             src="./close.png"
             alt="close"
             width="24"
             height="24">
        <table class="table">
          <tr class="tr-title">
            <th class="th">上课日期</th>
            <th class="th">学员</th>
            <th class="th">电话</th>
            <th class="th">报名时间</th>
          </tr>
          <template v-for="item in enrollList">
            <tr class="tr-content">
              <td class="td">{{item.startdate.substring(0, 11)}}</td>
              <td class="td">{{decodeURIComponent(item.username)}}</td>
              <td class="td">{{decodeURIComponent(item.phone)}}</td>
              <td class="td">{{decodeURIComponent(item.addtime).substring(0, 16)}}</td>
            </tr>
          </template>
        </table>
      </div>
    </div>
    <div class="newpop-mask" v-if="newShow">
      <div class="newpop">
        <h2 class="new-title">添加课件</h2>
        <img class='close'
             @click="newShow=false;"
             src="./close.png"
             alt="close"
             width="24"
             height="24">
        <div class="block btn1" @click="showExistedWare">
          <img class='img' src="./btn1.png" alt="add" width="30" height="30">
          <span class="text">选择已有课件</span>
        </div>
        <div class="block btn2">
          <img class='img' src="./btn2.png" alt="add" width="30" height="30">
          <span class="text">选择文件上传</span>
          <input class="input-file"
                 type="file"
                 accept=".pdf,.ppt,.pptx,.doc,.docx"
                 @change="upFile">
        </div>
        <p class="newpop-hint">*课件上传之后如果显示格式不对，请把文件另存为pptx或者pdf格式后重新上传</p>
      </div>
    </div>
    <div class="chantime-mask" v-if="changetimeShow">
      <div class="chantime">
        <p class="img-wrapper">
          <img class='close'
               @click="newShow=false;"
               src="./changetime-hint.png"
               alt="close"
               width="128"
               height="128">
        </p>
        <h2 class="chantime-title">全优在线更新提示！</h2>
        <p class="changetime-para">各位老师注意了！全优在线更新内容：不是当天的课程，以后不可以进入直播间，老师可以选择修改上课时间再进入直播间</p>
        <button class="changetime-btn confirm" @click="goChangeTime">修改时间上课</button>
        <button class="changetime-btn cancel" @click="changetimeShow=false">暂不修改</button>
      </div>
    </div>
    <!--分享班级二维码-->
    <share-school-page ref="shareclass"
                       :schoolinfo="schoolNow"
                       :lessoninfo="lessoninfo"
                       :classinfo="classinfo"
                       :title="'邀请学生'"></share-school-page>
  </div>

</template>

<script type="text/ecmascript-6">
  import {saveLocal, loadLocal} from 'common/js/store.js';
  import middleNav from 'components/middlenav/MiddleNav'
  import aboveNav from 'components/abovenav/AboveNav'
  import {clone} from 'common/js/clone';
  import Vue from 'vue';
  import {isSameDay} from 'common/js/calendar.js'
  import shareSchoolPage from 'components/shareschoolpage/ShareSchoolPage'

  export default {
    data() {
      return {
        id: (() => loadLocal('id', false))(),
        schoolNow: (() => loadLocal('schoolNow', false))(),
        lessoninfo: (() => loadLocal('lessoninfo', false))(),
        classinfo: (() => loadLocal('classinfo', false))(),
        imgprefix: (() => loadLocal('imgprefix', false))(),
        middleList: [
          {
            name: '课程表',
            to: '/console/lesson/class/schedule',
          },
          {
            name: '班级成员',
            to: '/console/lesson/class/member',
          }
        ],
        //----课时信息-----//
        classHourInfo: null,
        //----试听班显示课件-----//
        freeWareShow: false,
        //-------------------以下内容和课程表有关----------------------//
        currentPage: 1,
        totoalPage: 0,
        scheduleList: [],           //课程表列表
        returnServerToday: null,     //服务端返回的今天日期
        //-------------------以下内容和课件有关----------------------//
        newShow: false,
        fileName: '',
        loading: null,
        warePopShow: false,
        classWareList: [],      //仅与试听课的课件相关
        lessonWareList: [],
        count: 0,
        nowIndex: 0,
        nowCatalog: null,
        //-------------------以下内容和修改目录有关----------------------//
        catalogShow: false,
        currentCatalog: 1,         //修改目录时，当前选择的页数
        catalogList: [],           //用来存放从后端请求来的数据
        catalogListChange: [],     //用来存放用户修改的数据
        //--------报名列表----------//
        enrollShow: false,
        enrollList: [],
        //--------修改时间提示----------//
        changetimeShow: false,

      }
    },
    methods: {
      // 隐藏编辑班级弹窗
      hideDialog () {
        this.dialogVisible = false
      },

      isSameDay(one, two) {
        return isSameDay(one, two);
      },
      isEmpty(obj) {
        for (let i in obj) {
          return !1;
        }
        return !0;
      },
      computeTotalHour(item) {
        let hour = Math.floor(item / 60);
        let minutes = item % 60;
        return `${hour}小时${minutes}分钟`
      },
      computeUrl(url) {
        if (url === '') {
          return require('./cover.png');
        } else {
          return this.imgprefix + url;
        }
      },
      //获取试听课的课件
      openFreeCourseWare() {
        if (this.freeWareShow === false) {
          this.getFreeCourseWare();
        }
        this.freeWareShow = !this.freeWareShow
      },
      getFreeCourseWare() {
        this.classWareList = [];
        let item = this.scheduleList[0];
        //接口：查询课件在课程目录中的列表内容
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'ClassCourseWare',
            a: 'QueryClassCourseWare',
            id: this.id,
            classcatalogid: item.id,
            pageno: 1,
            pagesize: 200,
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
          }
          this.classWareList = response.list;
          this.$forceUpdate();
        }).catch((err) => {
          this.$alert('未获取到数据，请重新加载页面', '提示', {
            confirmButtonText: '刷新',
            callback: action => {
              window.location.reload();
            }
          });
        });
      },
      //显示添加课件
      showFreeAddWare() {
        this.newShow = true;
      },
      showCostAddWare(item, index) {
        this.nowCatalog = item;
        this.nowIndex = index;
        this.newShow = true;
      },
      showExistedWare() {
        this.lessonWareList = [];
        this.newShow = false;
        this.warePopShow = true;
        let item;
        //如果是试听课,item为课程表的第一项
        if (this.classinfo.democlass == '1') {
          item = this.scheduleList[0];
        } else {
          item = this.nowCatalog;
        }
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'CourseWare',
            a: 'QueryCourseWares',
            id: this.id,
            queryrid: item.rid,
            lessonid: item.lessonid,
            pageno: 1,
            pagesize: 300,
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
          }
          this.lessonWareList = response.list;
          if (this.lessonWareList != null) {
            this.lessonWareList.forEach(function (ele) {
              ele.show = false;
            })
          }
        }).catch((err) => {
          this.$alert('未获取到数据，请重新加载页面', '提示', {
            confirmButtonText: '刷新',
            callback: action => {
              window.location.reload();
            }
          });
        });

      },
      //预览课件
      previewWare(item) {
        window.open(`${this.GLOBAL.playUrl}v/${item.code}`);
      },
      //编辑课件
      editWare(item) {
        window.open(`${this.GLOBAL.editUrl}indexapp.php#/scene/create/${item.coursewareid}?pageId=1&sid=${this.id}`)
      },
      gotoLive(item) {
        if (this.isSameDay(this.returnServerToday, item.planstarttime.substring(0, 10))) {
          let id = this.id;
          let classid = item.classid;
          let rid = item.rid;
          let lessonid = item.lessonid;
          let catalogindex = item.catalog_index;
          let catalogid = item.id;
          window.open(`${this.GLOBAL.liveUrl}/live.html?sessionid=${id}&classid=${classid}&rid=${rid}&lessonid=${lessonid}&catalogid=${catalogid}&catalogindex=${catalogindex}`)
        } else {
          this.changetimeShow = true;
        }


      },
      goChangeTime() {
        this.$router.push('/console/calendar/schooltime');
      },
      reviewLive(item) {
        let id = this.id;
        let classid = item.classid;
        let rid = item.rid;
        let lessonid = item.lessonid;
        let catalogindex = item.catalog_index;
        let catalogid = item.id;
        window.open(`${this.GLOBAL.liveUrl}/review.html?sessionid=${id}&classid=${classid}&rid=${rid}&lessonid=${lessonid}&catalogid=${catalogid}&catalogindex=${catalogindex}`)
      },
      //显示试听课报名人数
      showEnrollPeople(item) {
        if (item.enrollnums != 0) {
          this.QueryClassUser(item);
          this.enrollShow = true;
        }
      },
      QueryClassUser(item) {
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'ClassUser',
            a: 'QueryClassUser',
            id: this.id,
            rid: item.rid,
            lessonid: item.lessonid,
            classid: item.classid,
            catalog_index: item.catalog_index,
            pageno: 1,
            pagesize: 100,
            count: 1
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
          }
          if (response.code === 200) {
            this.enrollList = response.list;
            this.enrollTotal = response.recordcount;
            this.$forceUpdate();
          }
        }).catch((err) => {
          this.$alert('未获取到数据，请重新加载页面', '提示', {
            confirmButtonText: '刷新',
            callback: action => {
              window.location.reload();
            }
          });
        });
      },
      //删除课件--试听
      delFreeWare(item, index) {
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'ClassCourseWare',
            a: 'DeleteClassCourseWare',
            id: this.id,
            rid: item.rid,
            lessonid: item.lessonid,
            classid: item.classid,
            coursewareid: item.coursewareid,
            classcatalogid: item.classcatalogid,
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
          }
          if (response.code === 200) {
            this.classWareList.splice(index, 1);
            this.$message({
              message: '删除成功',
              type: 'success'
            })
            this.scheduleList[0].coursewarenums = response.coursewarenums;
          }
        }).catch((err) => {
          this.$alert('请求失败，请重试', '提示', {
            confirmButtonText: '确定',
          });
        });
        this.$forceUpdate()  // 迫使 Vue 实例重新渲染。
      },
      //删除课件--收费
      delCostWare(item, index, index2) {
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'ClassCourseWare',
            a: 'DeleteClassCourseWare',
            id: this.id,
            rid: item.rid,
            lessonid: item.lessonid,
            classid: item.classid,
            coursewareid: item.coursewareid,
            classcatalogid: item.classcatalogid,
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
          }
          if (response.code === 200) {
            this.scheduleList[index].coursewarenums = response.coursewarenums;
            let tempList = this.scheduleList[index].coursewarelist;
            tempList.splice(index2, 1);
            this.$message({
              message: '删除成功',
              type: 'success'
            })
            this.$forceUpdate()
          }
        }).catch((err) => {
          this.$alert('请求失败，请重试', '提示', {
            confirmButtonText: '确定',
          });
        });

      },
      checkCourseWare(item, index) {
        if (item.show) {
          this.hideCourseWare(item);
        } else {
          this.getCourseWare(item, index);
        }
      },
      //获取收费课的课件
      getCourseWare(item, index) {
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'ClassCourseWare',
            a: 'QueryClassCourseWare',
            id: this.id,
            classcatalogid: item.id,
            pageno: 1,
            pagesize: 100,
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
          }
          if (response.code === 200) {
            item.coursewarelist = response.list;
//              Vue.set(item, coursewarelist, response.list);
            this.$forceUpdate();
          }
        }).catch((err) => {
          this.$alert('未获取到数据，请重新加载页面', '提示', {
            confirmButtonText: '刷新',
            callback: action => {
              window.location.reload();
            }
          });
        });
        item.show = true;
        this.$forceUpdate();
      },
      //隐藏收费课的课件
      hideCourseWare(item) {
        item.show = false;
        this.$forceUpdate();
      },
      //-------------------以下内容开始和修改课程表有关----------------------//
      loadSchedule(page) {
        //接口：修改班级资料（ispublish：是否上架1为上架，0为下架）
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'ClassCatalog',
            a: 'QueryNewClassCatalogs',
            id: this.id,
            isstudent: 0,
            classid: this.classinfo.id,
            pageno: page,
            pagesize: 10,
            count: 1
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
          }
          if (response.code === 200) {
            if (!this.returnServerToday) {
              this.returnServerToday = response.date;
            }
            this.totoalPage = Number(response.recordcount);
            let list = response.list;
            for (let i = 0; i < list.length; i++) {
              list[i].show = false;
              list[i].coursewarelist = null;
              this.scheduleList[(page - 1) * 10 + i] = list[i];
            }
            this.$forceUpdate();
          }
        }).catch((err) => {
          this.$alert('未获取到数据，请重新加载页面', '提示', {
            confirmButtonText: '刷新',
            callback: action => {
              window.location.reload();
            }
          });
        })
      },
      handleCurrentChange(val) {
        this.loadSchedule(val);
      },
      //-------------------以下内容开始和添加课件有关----------------------//
      gotoMake() {
        this.$router.push('/console/lesson/ware');
      },
      show(item, index) {
        Vue.set(this.lessonWareList[index], 'show', true);
        this.count++;
        this.$forceUpdate();
      },
      addWare() {
        if (this.lessonWareList == null) {
          this.warePopShow = false;
          return;
        }
        let list = [];
        //根据lessonWareList中每个项的show是否为true，将其添加到list中
        for (let i = 0; i < this.lessonWareList.length; i++) {
          if (this.lessonWareList[i].show === true) {
            list.push(this.lessonWareList[i]);
          }
        }
        if (list.length === 0) {
          this.$message({
            message: '请选择相应的课件',
            type: 'waring',
          })
        } else {
          const loading = this.$loading({
            lock: true,
            text: '添加中',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          let count = 0;
          let classCatalogNow;
          //如果是试听课
          if (this.classinfo.democlass == '1') {
            classCatalogNow = this.scheduleList[0];
          } else {
            classCatalogNow = this.nowCatalog;
          }
          for (let i = 0; i < list.length; i++) {
            //接口：添加课件到对应的课程目录
            this.$http({
              url: '/indexapp.php',
              method: 'GET',
              params: {
                c: 'ClassCourseWare',
                a: 'AddClassCourseWare',
                id: this.id,
                rid: this.schoolNow.rid,
                lessonid: this.lessoninfo.id,
                classid: this.classinfo.id,
                coursewareid: list[i].sceneid,
                classcatalogid: classCatalogNow.id,
                coursewarename: list[i].coursewarename,
              }
            }).then((response) => {
              response = response.data;
              if (response.code === 111) {
                this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
              }
              if (response.code === 200 || response.code === 102) {
                count++;
                if (count === list.length) {
                  loading.close();
                  this.$message({
                    message: '添加成功',
                    type: 'success'
                  });
                  //如果是试听课，则重新获取试听课件
                  if (this.classinfo.democlass == '1') {
                    this.scheduleList[0].coursewarenums = response.coursewarenums;
                    this.getFreeCourseWare();
                  } else {
                    this.scheduleList[this.nowIndex].coursewarenums = response.coursewarenums;
                    this.refreshCostWare();
                  }
                  this.warePopShow = false;
                }
              }
            }).catch((err) => {
              this.$alert('请求失败，请重试', '提示', {
                confirmButtonText: '确定',
              });
              loading.close();
            });
          }
        }
      },
      refreshCostWare() {
        let item = this.nowCatalog;
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'ClassCourseWare',
            a: 'QueryClassCourseWare',
            id: this.id,
            classcatalogid: item.id,
            pageno: 1,
            pagesize: 100,
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
          }
          if (response.code === 200) {
            this.scheduleList[this.nowIndex].coursewarelist = response.list;
//              Vue.set(item, coursewarelist, response.list);
            this.$forceUpdate();
          }
        }).catch((err) => {
          this.$alert('未获取到数据，请重新加载页面', '提示', {
            confirmButtonText: '刷新',
            callback: action => {
              window.location.reload();
            }
          });
        });
        item.show = true;
        this.$forceUpdate();
      },
      upFile(e) {
        this.loading = this.$loading({
          lock: true,
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        let input = e.target;
        // 通过DOM取文件数据
        let file = input.files[0];
        this.fileName = file.name;
        let xhr = new XMLHttpRequest();
        //initiate request
        let url = '/indexapp.php?c=Upload&a=UploadFileNew&id=' + this.id;
        xhr.open('post', url, true);
        //set headers
        xhr.setRequestHeader('X-File-Name', encodeURI(file.name));
        xhr.addEventListener('load', this.uploadComplete, false);
        //send the file
        xhr.send(file);
        this.newShow = false;
      },
      uploadComplete: function (evt) {
        let response = evt.target.responseText;
        let jsonobj = JSON.parse(response);
        let item;
        if (this.classinfo.democlass == '1') {
          item = this.scheduleList[0];
        } else {
          item = this.nowCatalog;
        }
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'CourseWare',
            a: 'ImportCourseWareFromImages',
            id: this.id,
            rid: item.rid,
            lessonid: item.lessonid,
            classid: item.classid,
            classcatalogid: item.id,
            coursewarename: this.fileName,
            uploadfilename: jsonobj.image
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
          }
          if (response.code === 200) {
            if (this.classinfo.democlass == '1') {
              this.scheduleList[0].coursewarenums = response.coursewarenums;
              this.getFreeCourseWare();
            } else {
              this.scheduleList[this.nowIndex].coursewarenums = response.coursewarenums;
              this.refreshCostWare();
            }
            this.loading.close();
            this.$forceUpdate();
          } else {
            this.loading.close();
          }
        }).catch((err) => {
          this.$alert('未获取到数据，请重新加载页面', '提示', {
            confirmButtonText: '刷新',
            callback: action => {
              window.location.reload();
            }
          });
        });

      },
      //-------------------以下内容和修改目录有关----------------------//
      showCatalog() {
        this.catalogList = [];
        this.catalogListChange = [];
        this.catalogShow = true;
        this.loadCatalog(1);
        //页码置为1
        this.currentCatalog = 1;
      },
      loadCatalog(page) {
        //接口：查询班级课程目录列表
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'ClassCatalog',
            a: 'QueryNewClassCatalogs',
            id: this.id,
            classid: this.classinfo.id,
            isstudent: 0,
            pageno: page,
            pagesize: 20,
            count: 1,
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
          }
          if (response.code === 200) {
            let list = response.list;
            this.totoalPage = Number(response.recordcount);
            for (let i = 0; i < list.length; i++) {
              this.catalogList[(page - 1) * 20 + i] = list[i];  //解码listChange的name
              this.catalogList[(page - 1) * 20 + i].catalogname = decodeURIComponent(this.catalogList[(page - 1) * 20 + i].catalogname)
              let obj = clone(this.catalogList[(page - 1) * 20 + i]);
//              this.catalogListChange[(page - 1) * 20 + i] = clone(this.catalogList[(page - 1) * 20 + i]);
              Vue.set(this.catalogListChange, (page - 1) * 20 + i, obj);
            }
            this.$forceUpdate();
          }
        }).catch((err) => {
          this.$alert('未获取到数据，请重新加载页面', '提示', {
            confirmButtonText: '刷新',
            callback: action => {
              window.location.reload();
            }
          });
        })
      },
      ChangeCatalogPage(val) {
        if (this.catalogList[(val - 1) * 20] != undefined) {
          return;
        }
        this.loadCatalog(val);
      },
      //点击修改课程目录的确认按钮
      save() {
        let list = this.catalogList;
        let listChange = this.catalogListChange;
        for (let i = 0; i < listChange.length; i++) {
          if (listChange[i].catalogname == '') {
            return;
          }
        }
        let listPost = [];
        for (let i = 0; i < listChange.length; i++) {
          for (let j = 0; j < list.length; j++) {
            if (listChange[i].id === list[j].id) {
              if (listChange[i].catalogname !== list[j].catalogname) {
                listPost.push(listChange[i]);
              }
            }
          }
        }
        if (listPost.length === 0) {
          this.catalogShow = false;
        } else {
          const loading = this.$loading({
            lock: true,
            text: '上传中',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          let count = 0;
          for (let k = 0; k < listPost.length; k++) {
            //接口：修改班级课程目录名称
            this.$http({
              url: '/indexapp.php',
              method: 'GET',
              params: {
                c: 'ClassCatalog',
                a: 'UpdateClassCatalog',
                id: this.id,
                rid: this.schoolNow.rid,                //网校id
                catalogid: listPost[k].id,    //目录id，为QueryClassCatalogs返回的id
                catalog_index: listPost[k].catalog_index,
                catalogname: listPost[k].catalogname,
              }
            }).then((response) => {
              response = response.data;
              if (response.code === 111) {
                this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
              }
              if (response.code === 200) {
                count++;
                if (count === listPost.length) {
                  loading.close();
                  this.$message({
                    message: '修改目录成功',
                    type: 'success'
                  });
                  this.loadSchedule(1);
                  this.catalogShow = false;
                }
              }
            }).catch((err) => {
              this.$alert('请求失败，请重试', '提示', {
                confirmButtonText: '确定',
              });
              loading.close();
            })
          }
        }

      },
      // 查询班级课时详情
      queryClassHour() {
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'ClassHour',
            a: 'QueryClassHour',
            id: this.id,
            classid: this.classinfo.id,
            catalog_index: this.classinfo.catalog_index,
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
          }
          if (response.code === 200) {
            this.classHourInfo = response.list[0];
          }
        }).catch((err) => {

        })
      },

      // 分享班级
      shareClass () {
        this.$refs.shareclass.show()
      },
    },
    created() {
      this.loadSchedule(1);
      if (this.classinfo.democlass == '0') {
        this.queryClassHour();
      }

    },
    components: {
      middleNav,
      aboveNav,
      shareSchoolPage
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .schedule
    position fixed
    left: 160px
    top: 40px
    right: 0
    bottom: 0
    background #f2f2f2
    overflow auto
    .content-wrapper
      padding: 20px 0
      min-width: 1206px
      font-size: 0
      overflow auto
      .content
        margin-left: 20px
        padding-bottom: 20px
        width: 1166px
        .back
          width: 124px
          height: 34px
          line-height: 34px
          font-size: 14px
          color: #999
          text-align: center
          cursor pointer
          background: #fff
        .classinfo-wrapper
          margin: 20px 0
          padding: 30px
          height: 120px
          background: #fff
          .info-img
            float: left
            border-radius: 4px
          .classinfo-text-wrapper
            float: left
            margin-left: 20px
            .classinfo-text-title
              margin-bottom: 20px
              font-size: 24px
              color: #333
              font-weight: bold
              height: 31px
              line-height: 31px
            .classinfo-text-row
              margin-bottom: 12px
              font-size: 14px
              color: #a5a5a5
              height: 19px
              line-height: 19px
              .split {
                position: relative
                top: 3px
                display: inline-block
                height: 15px
                width: 1px
                margin: 0 20px
                background: #a5a5a5
              }
        .catalog-free-wrapper
          padding: 0 30px
          background: #fff
          .catalog-title
            font-size: 18px
            font-weight: bold
            color: #333
            height: 70px
            line-height: 70px
            .add-btn {
              float: right
              margin: 20px 0 0 10px
              width: 100px
              height: 30px
              line-height: 30px
              font-size: 14px
              color: #333
              border: 1px solid #e9e9e9
              border-radius: 4px
              box-sizing: border-box
            }
            .check-btn {
              float: right
              margin-top: 20px
              width: 100px
              height: 30px
              line-height: 30px
              font-size: 14px
              color: #333
              text-align: left
              text-indent: 14px
              border-radius: 4px
              border: 1px solid #e9e9e9
              box-sizing: border-box
              &.show {
                background: url('./up.png') no-repeat right 10px center / 14px 14px
              }
              &.not-show {
                background: url('./down.png') no-repeat right 10px center / 14px 14px
              }
            }
          .wareList-wrapper
            margin-top: 10px;
            padding: 15px 25px 30px
            background: #e4e4e4
            position: relative
            .already-title
              margin-bottom: 15px
              font-size: 14px
              color: #666666
              height: 20px
              line-height: 20px
            .ware-item
              height: 60px
              background: #ffffff
              border-radius: 4px
              margin-bottom: 10px
              &:last-child
                margin: 0
              .ware-img-wrapper
                float: left
                width: 60px
                height: 40px
                margin: 10px 0 0 15px
              .courseware-name
                margin-left: 10px
                float: left
                line-height: 60px
                font-size: 14px
                color: #000
              .courseware-btn-wrapper
                float: right
                height: 28px
                margin: 16px 15px 0 0
                .courseware-btn
                  height: 28px
                  width: 60px
                  font-size: 14px
                  box-sizing: border-box
                  text-align: center
                  border-radius: 4px
                  &.transparent
                    margin-right: 10px
                    line-height: 26px
                    color: #666666
                    border: 1px solid #d7d7d7
                    background: #fafafa
                  &.del
                    line-height: 28px
                    background #ff6666
                    color: #fff
          .catalog-list-wrapper
            .catalog-list-item
              height: 60px
              border-top: 1px solid #e9e9e9
              position: relative
              .catalog-item-time
                margin-right: 30px
                float: left
                font-size: 14px
                color: #000000
                line-height: 60px
              .not-start, .ongoing
                float: left
                height: 60px
                line-height: 60px
                font-size: 16px
                color: #ff0000
              .done {
                margin-top: 10px
                float: left
                width: 52px
                height: 40px
                background: url('./finish.png') no-repeat center / 52px 40px
              }
              .enroll-check
                margin: 15px 0 0 0
                float: right
                display: inline-block
                padding-left: 10px
                height: 30px
                line-height: 30px
                font-size: 12px
                color: #999
                background: #f2f2f2
                position: relative
                .check
                  display: inline-block
                  width: 40px
                  text-align: center
                  color: #6cabdd
                  cursor: pointer
                  &.not-allow
                    cursor: not-allowed

              .go-class, .back-live, .add-ware-btn {
                float: right
                margin: 15px 0 0 10px
                width: 100px
                height: 30px
                line-height: 30px
                font-size: 14px
                color: #ffffff
                border-radius: 4px
                box-sizing: border-box
              }
              .go-class {
                background #3399ff
              }
              .back-live {
                background #d9a60d
              }
        .catalog-cost-wrapper
          padding: 0 30px 30px
          background: #fff
          .catalog-title-wrapper
            height: 70px
            overflow: hidden
            .catalog-title
              float: left
              font-size: 18px
              color: #333
              font-weight: bold
              height: 70px
              line-height: 70px
            .hint
              float: left
              margin-left: 20px
              background: url('./hint.png') no-repeat left 0 center / 17px 17px
              height: 70px
              line-height: 70px
              font-size: 14px
              color: #ff0000
              padding-left: 21px
            .add-btn
              float: right
              margin-top: 20px
              display: inline-block
              height: 30px
              width: 100px
              font-size: 14px
              color: #ffffff
              text-align: center
              line-height: 30px
              background #3399ff
              border-radius: 4px

          .catalog-list-wrapper
            .catalog-list-item
              height: 60px
              border-top: 1px solid #e9e9e9
              position: relative
              .catalog-item-title {
                float: left
                margin-right: 30px
                font-size: 16px
                color: #333
                height: 60px
                line-height: 60px
              }
              .not-start, .ongoing
                float: left
                height: 60px
                line-height: 60px
                font-size: 16px
                color: #ff0000
              .done {
                margin-top: 10px
                float: left
                width: 52px
                height: 40px
                background: url('./finish.png') no-repeat center / 52px 40px
              }

              .go-class, .back-live, .add-ware-btn {
                float: right
                margin: 15px 0 0 10px
                width: 100px
                height: 30px
                line-height: 30px
                font-size: 14px
                color: #ffffff
                border-radius: 4px
                box-sizing: border-box
              }
              .go-class {
                background #3399ff
              }
              .back-live {
                background #d9a60d
              }
              .add-ware-btn {
                color: #333
                border: 1px solid #e9e9e9
              }
              .check-btn {
                float: right
                margin-top: 15px
                width: 100px
                height: 30px
                line-height: 30px
                font-size: 14px
                color: #333
                text-align: left
                text-indent: 14px
                border-radius: 4px
                border: 1px solid #e9e9e9
                box-sizing: border-box
                &.show {
                  background: url('./up.png') no-repeat right 10px center / 14px 14px
                }
                &.not-show {
                  background: url('./down.png') no-repeat right 10px center / 14px 14px
                }
              }
              .catalog-item-time {
                float: right
                margin-right: 30px
                line-height: 60px
                font-size: 14px
                color: #999
              }

            .wareList-wrapper
              padding: 20px 30px
              background: #e4e4e4
              position: relative
              .ware-item
                height: 60px
                background: #ffffff
                border-radius: 4px
                margin-bottom: 10px
                &:last-child
                  margin: 0
                .ware-img-wrapper
                  float: left
                  width: 60px
                  height: 40px
                  margin: 10px 0 0 15px
                .courseware-name
                  margin-left: 10px
                  float: left
                  line-height: 60px
                  font-size: 14px
                  color: #000
                .courseware-btn-wrapper
                  float: right
                  height: 28px
                  margin: 16px 15px 0 0
                  .courseware-btn
                    height: 28px
                    width: 60px
                    font-size: 14px
                    box-sizing: border-box
                    text-align: center
                    border-radius: 4px
                    &.transparent
                      margin-right: 10px
                      line-height: 26px
                      color: #666666
                      border: 1px solid #d7d7d7
                      background: #fafafa
                    &.del
                      line-height: 28px
                      background #ff6666
                      color: #fff
    .catalogPop
      position: fixed
      top: 0
      bottom: 0
      left: 0
      right: 0
      display: flex
      background: rgba(0, 0, 0, 0.3)
      overflow: auto
      .catalogPop-content-wrapper
        margin: auto
        width: 1166px
        padding: 30px 53px 50px
        border-radius: 4px
        background: #ffffff
        font-size: 0
        box-sizing border-box
        .title
          margin-left: 27px
          line-height: 40px
          font-size: 20px
          color: #000000
          font-weight: bold
        .totalnum
          margin: 8px 0 25px 27px
          line-height: 24px
          font-size: 16px
          color: #555
        .catalog-wrapper
          width: 1060px
          padding: 30px 42px 25px
          background #f8f8f8
          box-sizing border-box
          .list
            display: inline-block
            width: 455px
            vertical-align top
            .row
              height: 35px
              width: 455px
              margin-bottom: 10px
              .index
                display: inline-block
                width: 35px
                height: 35px
                line-height: 35px
                font-size: 13px
                color: #999
              .text
                padding-left: 10px
                width: 420px
                height: 35px
                font-size: 15px
                color: #000
                text-align: left
                box-sizing: border-box
                border: 1px solid #d7d7d7
                border-radius: 4px
                &::-webkit-input-placeholder
                  color: red
              .text.danger
                border: 1px solid red

          .split
            display: inline-block
            height: 450px
            width: 30px
            border-right: 6px dashed #d7d7d7
            margin-right: 30px
        .btn-wrapper-out
          margin-top: 70px
          .btn-wrapper-inside
            margin: 0 auto
            width: 225px
            .cancel, .confirm
              width: 80px
              height: 34px
              line-height: 34px
              font-size: 16px
              text-align: center
              color: #ffffff
              border-radius: 4px
            .cancel
              margin-right: 65px
              background #ccc
            .confirm
              background: #3399ff

    .warePop
      position: fixed
      top: 0
      bottom: 0
      left: 0
      right: 0
      display: flex
      background: rgba(0, 0, 0, 0.3)
      overflow: auto
      .ware-content-wrapper
        margin: auto
        width: 720px
        padding: 30px 60px 40px
        border-radius: 4px
        background: #ffffff
        font-size: 0
        box-sizing border-box
        .ware-title
          font-size: 24px
          color: #000000
          font-weight: bold
          line-height: 40px
        .flex-wrapper
          margin: 25px 0 8px 0
          display: flex
          justify-content space-between
          .left
            font-size: 14px
            color: #000000
            line-height: 19px
          .right
            font-size: 14px
            color: #3399ff
            line-height: 19px
            cursor: pointer
        .ware-wrapper
          width: 600px
          height: 450px
          padding: 20px
          border: 1px solid #e4e4e4
          box-sizing border-box
          overflow auto
          .classware
            padding: 10px 0
            border-bottom: 1px solid #e4e4e4
            .cover
              vertical-align top
            .classware-middle
              display: inline-block
              margin-left: 10px
              vertical-align top
              .title
                font-size: 14px
                color: #000000
                line-height: 22px
              .introduce
                margin-top: 12px
                width: 400px
                height: 26px
                font-size: 12px
                color: #999999
                line-height: 13px
                overflow hidden
            .del
              position relative
              top: 20px
              margin-left: 20px
              cursor pointer

        .ware-btn-outside
          margin-top: 40px
          height: 34px
          .ware-btn-inside
            margin: 0 auto
            width: 225px
            .cancel, .confirm
              width: 80px
              height: 34px
              line-height: 34px
              text-align: center
              font-size: 16px
              color: #ffffff
              border-radius 4px
              box-sizing border-box
            .cancel
              margin-right: 65px
              background #ccc
            .confirm
              background #3399ff

    .enrollpop-wrapper
      position: fixed
      top: 0
      bottom: 0
      left: 0
      right: 0
      display: flex
      background: rgba(0, 0, 0, 0.3)
      z-index: 1000
      overflow: auto
      .enrollpop
        margin: auto
        width: 820px
        padding: 30px 60px
        border-radius: 4px
        background: #ffffff
        font-size: 0
        box-sizing border-box
        position relative
        .title
          margin-bottom: 15px
          font-size: 24px
          color: #000000
          font-weight: bold
          height: 34px
          line-height: 34px
        .sub-title
          margin-bottom: 10px
          font-size: 14px
          color: #000000
          height: 20px
          line-height: 20px
        .close
          position absolute
          top: 30px
          right: 20px
          cursor: pointer
        .table
          width: 700px
          background: #ffffff
          text-align: center
          font-size: 0
          table-layout: fixed
          border: 1px solid #e4e4e4
          .tr-title
            .th
              height: 40px
              line-height: 40px
              width: 175px
              font-size: 14px
              color: #fff
              background: rgba(0, 0, 0, 0.8)
              box-sizing: border-box
              border-right: 1px solid #fff
              &:last-child
                border: none
          .tr-content
            border-bottom: 1px solid #e4e4e4
            &:last-child
              border: none
            .td
              height: 40px
              line-height: 40px
              width: 233px
              font-size: 14px
              color: #000
              border-right: 1px solid #e4e4e4
              &:last-child
                border: none
    .newpop-mask
      position: fixed
      top: 0
      bottom: 0
      left: 0
      right: 0
      display: flex
      background: rgba(0, 0, 0, 0.3)
      z-index: 1000
      overflow: auto
      .newpop
        margin: auto
        padding: 30px 60px 60px
        border-radius: 4px
        background: #ffffff
        font-size: 0
        box-sizing border-box
        position relative
        .new-title
          font-size: 24px
          color: #000000
          font-weight: bold
          height: 34px
          line-height: 34px
        .close
          position absolute
          top: 30px
          right: 20px
          cursor: pointer
        .block
          margin-top: 20px
          padding: 0 35px
          height: 80px
          line-height: 80px
          border-radius: 4px
          cursor: pointer
          .img
            position relative
            top: 10px
          .text
            display inline-block
            width: 150px
            height: 80px
            line-height: 80px
            text-align: center
            font-size: 16px
            color: #ffffff
        .btn1
          margin-top: 40px
          background #3399ff
        .btn2
          background: #33cc33
          position relative
          .input-file
            position: absolute
            left: 0
            top: 0
            right: 0
            bottom: 0
            width: 100%;
            height: 100%;
            padding: 0
            margin: 0
            opacity: 0
            cursor: pointer
        .newpop-hint{
          margin-top:16px;
          line-height:14px;
          font-size:12px;
          color:#666;
          width: 250px;
        }
    .chantime-mask {
      position: fixed
      top: 0
      bottom: 0
      left: 0
      right: 0
      display: flex
      background: rgba(0, 0, 0, 0.3)
      overflow: auto
      .chantime {
        margin: auto
        height: 416px
        width: 460px
        padding: 30px 36px 45px
        border-radius: 4px
        background: #ffffff
        font-size: 0
        box-sizing border-box
        .img-wrapper {
          margin-bottom: 25px
          text-align: center
        }
        .chantime-title {
          text-align: center
          font-size: 20px
          color: #333333
          font-weight: bold
          height: 28px
          line-height: 28px
        }
        .changetime-para {
          margin: 15px 0 35px
          font-size: 16px
          color: #666666
          line-height: 24px
        }
        .changetime-btn {
          display: inline-block
          width: 180px
          height: 40px
          line-height: 40px
          font-size: 16px
          border-radius: 4px
          &.confirm {
            color: #ffffff
            background: #3399ff
            margin-right: 28px
          }
          &.cancel {
            background: #e4e4e4
            color: #333
          }
        }

      }
    }
</style>



// WEBPACK FOOTER //
// src/page/class/schedule/Schedule.vue